import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// eslint-disable-next-line no-restricted-imports
import { Menu } from 'semantic-ui-react';
import { getCurrentEnvironment } from '../../common/utils/environmentUtils';

// Import components.
import ChangeLanguage from '../../Components/Shared/ChangeLanguage';
import { routes } from '../../config/routes';
import { FeatureFlagsLink } from '../../feature-flags';
import UserProfileMenu from './UserProfileMenu';

import { NotificationsSidebar } from '@wonderschool/ccms-ui';
import { FoodProgramQueryProvider } from '@wonderschool/common-food-program-ui';
import { useCallback } from 'react';
import { RoleSwitcher } from '../../Components/RoleSwitcher/RoleSwitcher';
import WSA from '../../WSA';

const TopNavigation = ({ viewport = 'desktop', handleShowMenu }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isReady, isAuthenticated, authUser } = WSA.Components.useWSAuth();
  const environment = getCurrentEnvironment();

  // Memoize getAuthToken to prevent Apollo Client from being recreated on every render
  const getAuthToken = useCallback(async () => {
    return await authUser.getIdToken();
  }, [authUser]);

  // don't show if there's no user
  if (!isReady || !isAuthenticated) return null;

  const nav =
    viewport === 'mobile' ? (
      <Menu id="main-menu" stackable>
        <Menu.Item
          onClick={() => {
            handleShowMenu();
            navigate(routes.signout);
          }}
          content={t('navigation.userMenu.signOutAction')}
          style={{ cursor: 'pointer' }}
        />

        <Menu.Item>
          <FeatureFlagsLink mobile />
        </Menu.Item>

        <Menu.Item>
          <ChangeLanguage />
        </Menu.Item>

        <Menu.Item>
          <UserProfileMenu viewport="desktop" />
        </Menu.Item>
      </Menu>
    ) : (
      <Menu borderless className="top-nav">
        <Menu.Menu position="right">
          <Menu.Item>
            <FeatureFlagsLink mobile={false} />
          </Menu.Item>

          <Menu.Item>
            <ChangeLanguage />
          </Menu.Item>

          <Menu.Item>
            <FoodProgramQueryProvider getAuthToken={getAuthToken} environment={environment}>
              <NotificationsSidebar auth={WSA} />
            </FoodProgramQueryProvider>
          </Menu.Item>

          <Menu.Item>
            <RoleSwitcher />
          </Menu.Item>

          <UserProfileMenu />
        </Menu.Menu>
      </Menu>
    );

  return nav;
};

export default TopNavigation;
